module.exports = __webpack_public_path__ + "static/img/pinpaiqiyuan.744ce98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/pinpaiqiyuan.jpg
// module id = letY
// module chunks = 0